// extracted by mini-css-extract-plugin
export default {"TypeMenuButton":"TypeMenuButton33rA3eDXSd7e","TypeMenuButton_error":"TypeMenuButton_error28mHJoMf4Md4"};